import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { GenericTableComponent } from '../generic-table/component/generic-table.component';
import { SelectionDialogParams } from './selection-dialog.params';

@Component({
  selector: 'lib-selection-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatDialogModule,
    MatButtonModule,
    GenericTableComponent,
  ],
  templateUrl: './selection-dialog.component.html',
  styleUrl: './selection-dialog.component.scss',
})
export class SelectionDialogComponent<T> {
  private readonly _dialogRef = inject(MatDialogRef<SelectionDialogComponent<T>>);
  private readonly _cdRef = inject(ChangeDetectorRef);
  protected readonly params: SelectionDialogParams<T> = inject(MAT_DIALOG_DATA);

  protected currentSelection: T[] = [];

  protected get confirmDisabled(): boolean {
    return this.currentSelection.length === 0;
  }

  protected onSelectionChanged(items: T[]): void {
    this.currentSelection = items;
    this._cdRef.markForCheck();
    if (this.params.selectionMode !== 'multi') {
      this._dialogRef.close(items[0] ?? null);
    }
  }

  protected onRowDoubleClicked(item: T): void {
    if (this.params.selectionMode !== 'multi') {
      this._dialogRef.close(item);
    }
  }

  protected onConfirm(): void {
    this._dialogRef.close(this.currentSelection);
  }

  protected onCancel(): void {
    this._dialogRef.close(null);
  }
}
